import { apiGet } from './client.js';

export interface OnboardingStep {
  status: string;
  updated_at?: string | null;
  notes?: string | null;
}

export interface OnboardingProgressPayload {
  schema_version?: number;
  user?: {
    name?: string;
    email?: string;
    type?: string;
    buddy?: string | null;
    start_date?: string;
  };
  values_walkthrough?: string;
  steps?: Record<string, OnboardingStep>;
  admin_employee?: Record<string, OnboardingStep>;
  admin_contractor?: Record<string, OnboardingStep>;
  [key: string]: unknown;
}

export interface OnboardingProgress {
  email: string;
  userId: number | null;
  schemaVersion: number;
  userType: string | null;
  valuesWalkthrough: string | null;
  startedAt: string | null;
  lastUpdatedAt: string | null;
  completedAt: string | null;
  payload: OnboardingProgressPayload;
}

export async function getUserOnboardingProgress(
  userId: number
): Promise<OnboardingProgress | null> {
  const res = await apiGet<{ data: OnboardingProgress | null }>(
    `/admin/users/${userId}/onboarding-progress`
  );
  return res.data;
}
